function Hero() {
  return (
    <section className="text-center mb-5">
      <h1 className="mb-3">Hi, I’m Fatima 👋</h1>
      <h4 className="text-muted mb-3">Junior Front-end Developer</h4>
      <p className="lead">
        I build clean, responsive, and user-friendly web interfaces using React
        and Bootstrap. Recently trained with SheCodes and now looking for my
        first Front-end Developer role.
      </p>
      <a href="#projects" className="btn btn-dark me-2">
        View Projects
      </a>
      <a href="#contact" className="btn btn-outline-dark">
        Contact Me
      </a>
    </section>
  );
}

export default Hero;
